const constants = {
  tokenSecret: "e01a4b78-d5ca-404e-a63c-7e8c032eeb38",
};

export default constants;
